exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq_area .card-header {\n  background-color: #0859A8;\n  color: #fff;\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0 !important;\n  cursor: pointer;\n}\n.faq_area .card {\n  margin-bottom: 1rem;\n}\n.faq_area .card-body {\n  border: 1px solid #0859A8;\n}", ""]);

// exports
